export const CHECKOUT_ENDPOINTS = {
  PREVIEW_ORDER: '/cart/review/',
  CHECKOUT: '/cart/checkout/',
  ORDER_STATUS: '/cart/order-status/',
  CANCEL_ORDER: '/order/cancel/',
  CANCEL_ORDER_CONFIRM: '/order/cancel/confirm/',
  ORDER_BY_NUMBER: '/cart/order/',
  CHECKOUT_STATUS: '/order/checkout-status/',
} as const
